import React, { Component } from 'react';

import ProblematicServersComponent from './ProblematicServicesComponent'
import { actions } from './ProblematicServicesReducer'
import { connect } from 'react-redux'

class Wrapper extends Component {
    componentDidMount() {
        this.props.fetch();
    }
    render() {
        return (
            <React.Fragment>
                <ProblematicServersComponent {...this.props} />                
            </React.Fragment>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        isLoading: state.waas.problematicServices.problematicServices.isLoading || state.waas.problematicServices.fetcher.loading,
        items: state.waas.problematicServices.fetcher.items || []
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        fetch: () => {
            dispatch(actions.trigger())
        },
        reload: () => {
            dispatch(actions.trigger())
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Wrapper)